import { gql } from '@apollo/client';

export const ADD_UPDATE_FINANCIAL_PRODUCT_SEASONALITY_TEMPLATE = gql`
  mutation addOrUpdateFinancialProductSeasonalityTemplate($input: FinancialProductSeasonalityTemplateInput!) {
    addOrUpdateFinancialProductSeasonalityTemplate(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const REMOVE_FINANCIAL_PRODUCT_SEASONALITY_TEMPLATE = gql`
  mutation deleteFinancialProductSeasonalityTemplate($input: DeleteFinancialProductSeasonalityTemplate) {
    deleteFinancialProductSeasonalityTemplate(input: $input) {
      commandId
      correlationId
    }
  }
`;
